import React from "react";
import { Box, Toolbar, Typography } from "@mui/material";
import LoanSummaryTable from "../../components/loanSummaryTable/LoanSummaryTable";
import "./styles.scss";

const LoanSummary = () => {
  return (
    <>
      <Toolbar
        sx={{
          justifyContent: "space-between",
          margin: "0px 15px",
        }}
      >
        <Typography className="transactions-history-title">
          Loan Statement Summary
        </Typography>
      </Toolbar>
      <Box sx={{ margin: "20px 40px" }}>
        <LoanSummaryTable />
      </Box>
    </>
  );
};

export default LoanSummary;
